
import React from 'react';
import RegistrationGuard from "@/components/auth/RegistrationGuard";

const LoadingState: React.FC = () => {
  return (
    <RegistrationGuard>
      <div className="space-y-8 animate-fade-in">
        <div>
          <h1 className="text-3xl font-bold">Escolha seu Psicólogo</h1>
          <p className="text-muted-foreground">Carregando psicólogos disponíveis...</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="animate-pulse bg-gray-200 h-64 rounded-lg"></div>
          ))}
        </div>
      </div>
    </RegistrationGuard>
  );
};

export default LoadingState;
